module.exports = __webpack_public_path__ + "images/ico-userblue.svg?e1f6ccdb885892de07eddc0f9cef3730";